import {COMP_TYPES} from '../../../constants/constants'
import type {ComponentRepository} from '../repository/ComponentRepository'

export interface WidgetSlotPlaceholder {
    compRefId: string
    slotKeyName: string
}

export class SlotsPlaceholderService {
    constructor(private readonly componentRepository: ComponentRepository) {}

    /*
     * @description Get all slot placeholders by page id
     * @param pageId - The id of the page to get the slot placeholders. For blocks it's the widget page id
     * @returns An array of slot placeholders
     */
    getSlotsPlaceholderByPageId(pageId: string): WidgetSlotPlaceholder[] {
        const slotsComponents = this.componentRepository.getComponentsByTypeForPage(pageId, COMP_TYPES.SLOT_PLACEHOLDER)
        const [rootAppWidgetPointer] = this.componentRepository.getComponentsByTypeForPage(
            pageId,
            COMP_TYPES.APP_WIDGET_TYPE
        )

        if (!rootAppWidgetPointer) {
            throw new Error('Root AppWidget not found')
        }

        return slotsComponents.map<WidgetSlotPlaceholder>(slotPointer => {
            const nickname = this.componentRepository.getRoleByWidgetRoot(slotPointer, rootAppWidgetPointer)
            if (!nickname) {
                throw new Error('Nickname not found for component')
            }

            return {
                compRefId: slotPointer.id,
                slotKeyName: nickname
            }
        })
    }
}
